import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Calculator } from "@phosphor-icons/react";

export const InputForm = ({ formData, onChange, loading }) => {
  const handleInputChange = (field, value) => {
    const numValue = parseFloat(value) || 0;
    onChange({ ...formData, [field]: numValue });
  };

  const inputGroups = [
    {
      title: "Current Portfolio",
      fields: [
        { key: "current_aum", label: "Current MF AUM", prefix: "₹", step: 100000 },
        { key: "current_sip_book", label: "Current SIP Book (p.m.)", prefix: "₹", step: 10000 }
      ]
    },
    {
      title: "Monthly Targets",
      fields: [
        { key: "monthly_lumpsum", label: "Lumpsum MF (p.m.)", prefix: "₹", step: 10000 },
        { key: "monthly_sip", label: "New SIP (p.m.)", prefix: "₹", step: 5000 }
      ]
    },
    {
      title: "Projection Settings",
      fields: [
        { key: "years_in_business", label: "Years in Business", suffix: "years", step: 1 },
        { key: "redemption_rate", label: "AUM Redemption Rate", suffix: "%", step: 0.5 },
        { key: "market_growth_rate", label: "Market Growth Rate (p.a.)", suffix: "%", step: 0.5 },
        { key: "brokerage_rate", label: "Brokerage Rate (p.a.)", suffix: "%", step: 0.1 }
      ]
    }
  ];

  return (
    <div className="bg-white rounded-sm border border-slate-200 p-6 lg:p-8" data-testid="input-form">
      <div className="flex items-center gap-3 mb-6 pb-6 border-b border-slate-200">
        <Calculator size={24} weight="duotone" className="text-emerald-700" />
        <h2 className="text-xl font-semibold tracking-tight text-slate-900">Input Parameters</h2>
      </div>

      <div className="space-y-8">
        {inputGroups.map((group, idx) => (
          <div key={idx}>
            <p className="text-xs uppercase tracking-[0.2em] font-medium text-slate-500 mb-4">
              {group.title}
            </p>
            <div className="space-y-4">
              {group.fields.map((field) => (
                <div key={field.key}>
                  <Label 
                    htmlFor={field.key} 
                    className="text-sm font-medium text-slate-700 mb-2 block"
                  >
                    {field.label}
                  </Label>
                  <div className="relative">
                    {field.prefix && (
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 font-mono text-sm">
                        {field.prefix}
                      </span>
                    )}
                    <Input
                      id={field.key}
                      type="number"
                      value={formData[field.key]}
                      onChange={(e) => handleInputChange(field.key, e.target.value)}
                      step={field.step}
                      disabled={loading}
                      className={`font-mono h-11 rounded-sm border-slate-300 focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 transition-colors ${
                        field.prefix ? 'pl-8' : ''
                      } ${
                        field.suffix ? 'pr-12' : ''
                      }`}
                      data-testid={`input-${field.key}`}
                    />
                    {field.suffix && (
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 font-mono text-sm">
                        {field.suffix}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 pt-6 border-t border-slate-200">
        <p className="text-xs text-slate-500 leading-relaxed">
          Adjust the parameters above to see real-time projections of your trail revenue. 
          All calculations update automatically.
        </p>
      </div>
    </div>
  );
};

export default InputForm;